import * as r from 'ramda';

export function isOnlyDoughSelected(state) {
    let doughCount = r.sum(
        r.values(
            r.map(
                (config) => config.count,
                r.filter(
                    (config) => config.isDough,
                    r.path(['productConfigurator', 'productConfigs'], state)
                )
            )
        )
    );

    let otherCount = r.sum(
        r.values(
            r.map(
                (config) => config.count,
                r.filter(
                    (config) => !config.isDough,
                    r.path(['productConfigurator', 'productConfigs'], state)
                )
            )
        )
    );

    return doughCount > 0 && otherCount === 0;
}

export function idMozzarella(state) {
    let mozzarella = r.find(
        r.propEq('isMozzarella', true),
        r.values(r.path(['productConfigurator', 'productConfigs'], state))
    );

    if (typeof mozzarella === 'undefined') return null;
    return mozzarella.id;
}

export function mozzarellaCount(state, id) {
    return r.path(
        ['productConfigurator', 'productConfigs', id, 'count'],
        state
    );
}

export function pizzaContainsNoMozzarellaDialog(state) {
    return r.path(
        ['productConfigurator', 'pizzaContainsNoMozzarellaDialog'],
        state
    );
}

export function showPizzaContainsNoMozzarella(state) {
    return r.pathOr(
        false,
        ['productConfigurator', 'showPizzaContainsNoMozzarella'],
        state
    );
}

export function pizzaContainsOnlyDoughDialog(state) {
    return r.path(
        ['productConfigurator', 'pizzaContainsOnlyDoughDialog'],
        state
    );
}

export function showPizzaContainsOnlyDough(state) {
    return r.pathOr(
        false,
        ['productConfigurator', 'showPizzaContainsOnlyDough'],
        state
    );
}
